import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { verifyTokenForPoll as verifyTokenForPollAction } from 'actions/polls';
import BoxWrapper from 'components/atoms/BoxWrapper';
import { Container, Grid } from '@material-ui/core';
import LoadingScreen from 'components/molecules/LoadingScreen';
import { Redirect } from 'react-router';
import { routes } from 'routes/Routes';
import TypeformEmbed from 'components/atoms/TypeformEmbed';
import HeaderTemplate from 'templates/HeaderTemplate/HeaderTemplate';

const DailyPollPage = ({ location, verifyTokenForPoll, polls }) => {
    const { key, formId } = queryString.parse(location.search);
    const {
        isVerifyTokenForPollSuccess,
        isVerifyTokenForPollFailure,
        isVerifyTokenForPollRequest,
    } = polls;

    useEffect(() => {
        if (!isVerifyTokenForPollSuccess && !isVerifyTokenForPollFailure) {
            verifyTokenForPoll(key, formId);
        }
    }, []);

    return (
        <>
            <HeaderTemplate title="Daily Poll" />
            <Container>
                <BoxWrapper mt="10" mb="25">
                    <Grid container justify="center">
                        <Grid item xs={12} md={6}>
                            <TypeformEmbed veificationKey={key} formId={formId} />
                        </Grid>
                    </Grid>
                </BoxWrapper>
                {isVerifyTokenForPollRequest && <LoadingScreen />}
                {isVerifyTokenForPollFailure && <Redirect to={routes.dailyPollSuccessful} />}
            </Container>
        </>
    );
};

const mapStateToProps = ({ polls }) => {
    return { polls };
};

const mapDispatchToProps = (dispatch) => ({
    verifyTokenForPoll: (key, pollId) => dispatch(verifyTokenForPollAction(key, pollId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DailyPollPage);
